// extracted by mini-css-extract-plugin
export default {"postsWrapper":"heatmapSection_postsWrapper__aC95O"};